<template>
  <div class="goods_edit">
    <!--{{ result }}-->
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"

    >

      <el-form-item label="商品名称" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="货号" prop="art_num">
        <el-input v-model="ruleForm.art_num"></el-input>
      </el-form-item>
      <el-form-item label="重量" prop="weight">
        <el-input v-model="ruleForm.weight"></el-input>
      </el-form-item>
       <el-form-item label="商品类别"  prop="goods_cate" >
            <el-cascader
                    :value="default_options"
                    ref="cascader"
                    @change="change"
                    :options="cate_option"
                    :props="{checkStrictly: true }"
                    clearable></el-cascader>

        </el-form-item>


      <el-form-item v-for="(v, i) in attrs" :key="i" :label="v.name">
        <el-checkbox-group v-model="checkList[i].list" @change="handleClick">
          <el-checkbox v-for="(k, j) in v.list" :key="j" :label="k" />
        </el-checkbox-group>
      </el-form-item>

      <div class="mt-20">
        <div>
          <el-tag
            v-for="(item, index) in skuList"
            :key="index"

            :disable-transitions="false"
             style="margin-right: 5px"

          >
            {{ item[0] }}{{ item[1] }}
          </el-tag>
        </div>

        <div class="price">
          <div class="title_bg">
            <el-button type="danger" size="small"
              >商品SKU </el-button>
          </div>
            <div class="title_bg" style="margin-top: 5px">


                <el-row >
                    <el-col :span="5">
                        <el-form-item label="价格">
                            <el-input v-model="batch_price"></el-input>

                        </el-form-item>
                    </el-col>
                    <el-col :span="5">


                        <el-form-item label="数量">
                            <el-input v-model="batch_qty"></el-input>

                        </el-form-item>
                    </el-col>
                    <el-col :span="5"><el-button @click="set_batch_price">设置批量价格与数量</el-button></el-col>
                </el-row>
            </div>

          <el-row
            :gutter="10"
            style="margin: 10px 10px"
            v-for="(item, index) in skuList"
            :key="index"
          >
            <el-col :span="15">
                <el-row>
                    <el-col :span="2">
                        <span class="box_text">{{item[0]}},{{item[1]}}</span>

                    </el-col>
                    <el-col :span="2"><span class="box_text"> 价格:</span></el-col>
                    <el-col :span="4"> <el-input
                            v-model="price[item[0]+','+item[1]]"
                            placeholder="价格"
                            @input="attr_listen(item[0]+','+item[1], 'price')"

                    ></el-input></el-col>
                    <el-col :span="2"><span class="box_text">数量</span> </el-col>
                    <el-col :span="4">  <el-input
                            v-model="qty[item[0]+','+item[1]]"
                            placeholder="数量"
                            @input="attr_listen(item[0]+','+item[1], 'qty')"

                    ></el-input></el-col>
                </el-row>

            </el-col>

          </el-row>
        </div>

          <div class="pic" v-if="checkList.length>0" >
<!--              {{checkList[0]['list']}}-->
<!--              <br/>-->
<!--              skuListReg:{{skuListReg}}-->
<!--              <br/>-->
<!--              skuList: {{skuList}}-->
<!--              <br/>-->
<!--              checkList:{{checkList}}-->
<!--              <br/>-->
<!--              skuListAttrReg:{{skuListAttrReg}}-->
<!--              <br/>-->
<!--              skuListAttrIdReg:{{skuListAttrIdReg}}-->
<!--                <br/>-->
<!--              skuId:{{skuId}}-->
<!--              price:{{price}}-->
<!--              qty:{{qty}}-->
              <div v-for="(item, index) in checkList[0]['list']" :key="index">
                  <el-row style="margin-bottom: 10px; margin-top: 10px">
                      <el-col :span="10">

                          <el-tag

                                  :key="index"
                                  closable
                                  :disable-transitions="false"
                                  @close="picClose(item)"
                          >
                              {{item}}

                          </el-tag>


                          <el-upload
                                  class="avatar-uploader"
                                  name="file"
                                  :action="url"
                                  list-type="picture-card"
                                  :on-success="handleAvatarSuccess"
                                  :on-remove="handleRemove"
                                  :data="{ key: index }"
                                  :before-upload="beforeAvatarUpload"
                                  ref="pic_files"
                                  :fileList="skuListReg[item]?skuListReg[item]['data']:[]"


                          >
                              <i class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                      </el-col>
                  </el-row>
              </div>


          </div>
<!--        <div class="pic">-->
<!--          <div class="title_bg">-->
<!--            <el-button type="danger" size="small"-->
<!--              >上传图片<i class="el-icon-upload el-icon&#45;&#45;right"></i-->
<!--            ></el-button>-->
<!--          </div>-->

<!--          <div v-for="(item, index) in skuList" :key="index">-->
<!--            <el-row style="margin-bottom: 10px; margin-top: 10px">-->
<!--              <el-col :span="10">-->
<!--                  <p >{{item[0]}},{{item[1]}}</p>-->
<!--                <el-upload-->
<!--                  class="avatar-uploader"-->
<!--                  name="file"-->
<!--                  :action="url"-->
<!--                  list-type="picture-card"-->
<!--                  :on-success="handleAvatarSuccess"-->
<!--                  :on-remove="handleRemove"-->
<!--                  :data="{ key: index }"-->
<!--                  :before-upload="beforeAvatarUpload"-->
<!--                  ref="pic_files"-->
<!--                  :fileList="goods_pic_url[index]"-->
<!--                >-->
<!--                  <i class="el-icon-plus avatar-uploader-icon"></i>-->
<!--                </el-upload>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </div>-->
<!--        </div>-->
        <!--
        {{ price }}
        {{ qty }}
        -->
      </div>
      <div>
        <div class="title_bg">
          <el-button type="danger" size="small"
            >展示图片<i class="el-icon-upload el-icon--right"></i
          ></el-button>
        </div>
        <el-row>
          <el-col :span="10">
            <el-upload
              class="avatar-uploader"
              name="file"
              :action="url"
              list-type="picture-card"
              :on-success="goodsSuccess"
              :on-remove="handleShowRemove"
              :data="{ key: 'uploads' }"
              :before-upload="beforeAvatarUpload"
              ref="pic_show"
              :fileList="goods_show_pic"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <!-- {{ this.goods_show_pic }} -->
          </el-col>
        </el-row>
      </div>

      <el-form-item label="零售价格" prop="price">
        <el-input v-model="ruleForm.price"></el-input>
      </el-form-item>
      <el-form-item label="吊牌价" prop="tag_price">
        <el-input v-model="ruleForm.tag_price"></el-input>
      </el-form-item>

      <el-form-item label="描述">
        <quill-editor
          ref="myQuillEditor"
          v-model="ruleForm.content"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @ready="onEditorReady($event)"
        />
      </el-form-item>
      <br />
      <br />
      <br />

      <el-form-item class="quill-editor-top">
        <el-button type="primary" @click="submitForm('ruleForm')">立即更新</el-button>
        <el-button @click="resetForm('ruleForm')" ref="ruleForm">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// import axios from "axios"
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], //加粗，斜体，下划线，删除线
  ["blockquote", "code-block"], //引用，代码块

  [
    {
      header: 1,
    },
    {
      header: 2,
    },
  ], // 标题，键值对的形式；1、2表示字体大小
  [
    {
      list: "ordered",
    },
    {
      list: "bullet",
    },
  ], //列表
  [
    {
      script: "sub",
    },
    {
      script: "super",
    },
  ], // 上下标
  [
    {
      indent: "-1",
    },
    {
      indent: "+1",
    },
  ], // 缩进
  [
    {
      direction: "rtl",
    },
  ], // 文本方向

  [
    {
      size: ["small", false, "large", "huge"],
    },
  ], // 字体大小
  [
    {
      header: [1, 2, 3, 4, 5, 6, false],
    },
  ], //几级标题

  [
    {
      color: [],
    },
    {
      background: [],
    },
  ], // 字体颜色，字体背景颜色
  [
    {
      font: [],
    },
  ], //字体
  [
    {
      align: [],
    },
  ], //对齐方式

  ["clean"], //清除字体样式
  ["image", "video"], //上传图片、上传视频
];
import { mapActions, mapState } from "vuex";
import url from "../utils/urls";
export default {
  data() {
    return {
      url: url.root + "/admin/upload/index",
      id: "",
      cate_option:[],
      default_options:[],
      cate_path:[],

      goods_pic_url: [],

      goods_show_pic: [],
        batch_price:0,
        batch_qty:1,
      attrs: [],

      checkList: [],
      skuArray: [],
      skuList: [],
      skuListReg: {},
      skuListAttrReg: {},
      skuListAttrIdReg: {},
      skuId: {},

      qty: {},
      price: {},

      demotext: "",

      dynamicValidateForm: {
        domains: [
          {
            value: "",
          },
        ],
        email: "",
      },
      content: "",
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
          },
        },
        placeholder: "编辑文章内容",
      },
      ruleForm: {
        name: "",
        art_num: "",
        weight: "",
        price: "",
        tag_price: "",
        cate: "",
        goods_cate:"",


        colors: [],

        content: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur",
          },
          {
            min: 5,
            max: 100,
            message: "长度在 5 到 100 个字符",
            trigger: "blur",
          },
        ],
        art_num: [
          {
            required: true,
            message: "请输入货号",
            trigger: "blur",
          },
        ],

        weight: [
          {
            required: true,
            message: "请输入重量",
            trigger: "blur",
          },
        ],

       goods_cate: [
              {
                  required: true,
                  message: "请选择商品类别",
                  trigger: "change",
              },
          ],
      },
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
    ...mapState({
      result: (state) => state.goods.result,
      category: (state) => state.category.result,
      attr: (state) => state.attr.result,
    }),
  },
  methods: {
    ...mapActions({
      editGoodsAction: "editGoodsAction",
      getCategoryDataAction: "getCategoryDataAction",
      getAttrDataAction: "getAttrDataAction",
    }),
    set_batch_price(){
          for (let item in this.price){
              this.$set(this.price, item, this.batch_price);

          }
        for (let item in this.qty){
            this.$set(this.qty, item,  this.batch_qty);

        }
          // this.price.forEach((element,i) => {
          //       alert(i)
          //     this.$set(this.price, i, this.batch_price);
          //     this.attr_listen(i, 'price')
          //
          //
          //
          // });
          // this.qty.forEach((element,i) => {
          //
          //     this.$set(this.qty, i, this.batch_qty);
          //     this.attr_listen(i, 'qty')
          //
          //
          //
          // });

      },
    attr_listen(index, type) {
      let sku_key = this.skuList[index].toString();

      if (type == "qty") {
        if (!(sku_key in this.skuListAttrReg)) {
          this.skuListAttrReg[sku_key] = [];
          this.$set(this.skuListAttrReg[sku_key], 1, this.qty[index]);
          this.$set(this.skuListAttrReg[sku_key], 0, this.price[index]);
        } else {
          this.$set(this.skuListAttrReg[sku_key], 1, this.qty[index]);
        }
      }
      if (type == "price") {
        if (!(sku_key in this.skuListAttrReg)) {
          this.skuListAttrReg[sku_key] = [];
          this.$set(this.skuListAttrReg[sku_key], 0, this.price[index]);
          this.$set(this.skuListAttrReg[sku_key], 1, this.qty[index]);
        } else {
          this.$set(this.skuListAttrReg[sku_key], 0, this.price[sku_key]);
        }
      }
    },
    handleClose(tag) {
      var index = this.skuList.indexOf(tag);

      if (tag in this.skuListReg) {
        //删除指定键
        // delete this.skuListReg[tag];

        this.$delete(this.skuListReg, tag);
      }
      if (tag in this.skuListAttrReg) {
        //删除指定键
        // delete this.skuListAttrReg[tag];
        this.$delete(this.skuListAttrReg, tag);
      }
      if (tag in this.skuListAttrIdReg) {
        //删除指定键
        // delete this.skuListAttrReg[tag];
        this.$delete(this.skuListAttrIdReg, tag);
      }

      this.skuList.splice(index, 1);
      this.skuId.splice(index, 1);
      this.qty.splice(index, 1);
      this.price.splice(index, 1);
      this.goods_pic_url.splice(index, 1);
      if (this.skuList.length <= 0) {
        this.updateSkuList();
      }
    },

    picClose(tag) {
          // var index = this.skuList.indexOf(tag);
        let ids=[]
        for(let i=0;i<this.skuList.length;i++){
            if(this.skuList[i][0]==tag){
                ids.push(this.skuList[i].toString())

            }

        }


          if (tag in this.skuListReg) {
              //删除指定键
              // delete this.skuListReg[tag];

              this.$delete(this.skuListReg, tag);

          }
          let checkListLen=this.checkList.length
          if(checkListLen>0){
             let index= this.checkList[0]["list"].indexOf(tag)

              this.$delete(this.checkList[0]["list"], index);
             if(this.checkList[0]["list"].length==0){

                 // this.checkList=[]
                 this.$set(this.checkList[0],"list",[])
                 this.$set(this.checkList[1],"list",[])

             }

          }
        let idsLen=ids.length

        for(let i=0;i<idsLen;i++){
            let skuListItem=ids[i]
            for (let jj=0;jj<this.skuList.length;jj++){
                if(this.skuList[jj].toString()==skuListItem){
                    this.skuList.splice(jj,1)
                    break

                }
            }



        }
           // for(let i=0;i<idsLen;i++){
           //
           //     this.$delete(this.skuList, ids[i]);
           // }

        Object.keys(this.skuListAttrReg).forEach((k)=>{

           let key= k.split(",")
            if(key[0]==tag){
                this.$delete(this.skuListAttrReg, k);

            }


        });
        Object.keys(this.skuListAttrIdReg).forEach((k)=>{

            let key= k.split(",")
            if(key[0]==tag){
                this.$delete(this.skuListAttrIdReg, k);

            }


        });
        Object.keys(this.skuId).forEach((k)=>{

            let key= k.split(",")
            if(key[0]==tag){
                this.$delete(this.skuId, k);

            }


        });
        Object.keys(this.qty).forEach((k)=>{

            let key= k.split(",")
            if(key[0]==tag){
                this.$delete(this.qty, k);

            }


        });
        Object.keys(this.price).forEach((k)=>{

            let key= k.split(",")
            if(key[0]==tag){
                this.$delete(this.price, k);

            }


        });

        Object.keys(this.skuListReg).forEach((k)=>{

            let key= k.split(",")
            if(key[0]==tag){
                this.$delete(this.skuListReg, k);

            }


        });


          // if (tag in this.skuListAttrReg) {
          //     //删除指定键
          //     // delete this.skuListAttrReg[tag];
          //     this.$delete(this.skuListAttrReg, tag);
          // }
          // if (tag in this.skuListAttrIdReg) {
          //     //删除指定键
          //
          //     this.$delete(this.skuListAttrIdReg, tag);
          // }
          //
        for(let i=0;i<idsLen;i++){
        //     // this.skuList.splice(ids[i], 1);
        //     this.skuId.splice(ids[i], 1);
        //     this.qty.splice(ids[i], 1);
        //     this.price.splice(ids[i], 1);
            // this.$delete(this.skuList, ids[i]);
        }


      },
    //删除图片
    handleRemove(file, fileList) {
        console.log("handleRemove", file, "fileList", fileList);
        var filename = file.url;

        // let kk, jj,end;

        // for (let i = 0; i < this.goods_pic_url.length; i++) {
        //     kk = i;
        //     for (let j = 0; j < this.goods_pic_url[i].length; j++) {
        //         if (this.goods_pic_url[i][j]["url"] == filename) {
        //             jj = j;
        //             end=1
        //             console.log("kk", i, "jj", j, "filename", filename);
        //             break;
        //         }
        //     }
        //     if(end==1){
        //         break
        //     }
        // }

        let sku_reg_key;
        let sku_reg_kk;
        let sku_end=0;
        for (var key in this.skuListReg) {
            let sku_key = key.toString();

            for (let i = 0; i < this.skuListReg[sku_key]['data'].length; i++) {
                if (this.skuListReg[sku_key]['data'][i].url == filename) {
                    sku_reg_key = sku_key;
                    sku_reg_kk = i;
                    sku_end=1

                    break;
                }
            }
            if(sku_end==1){
                break
            }
        }

        if (sku_reg_key in this.skuListReg) {
            this.skuListReg[sku_reg_key]['data'].splice(sku_reg_kk, 1);
        }

        // this.goods_pic_url[kk].splice(jj, 1);

        // console.log("kk", kk, "jj", jj);
        // console.log("this.goods_pic_url", this.goods_pic_url[kk]);
    },

    //删除指定数组元数
    removeFile(file) {
      var filename = file.response.upload_filename;
      let key;
      for (let i = 0; i < this.goods_show_pic.length; i++) {
        if (this.goods_show_pic[i]["url"] == filename) {
          key = i;
          break;
        }
      }

      this.goods_show_pic.splice(key, 1);
    },
    handleShowRemove(file) {
      // this.removeFile(file);
      let name = file.name;

      let len = this.goods_show_pic.length;
      for (let i = 0; i < len; i++) {
        if (this.goods_show_pic[i]["name"] == name) {
          this.goods_show_pic.splice(i, 1);
          break;
        }
      }
    },
    //展示图片
    goodsSuccess(res, file) {
      this.goods_show_pic.push({
        name: "k_" + file.uid,
        url: file.response.upload_filename,
      });

      file.url = file.response.upload_filename;
    },
    //图片上传成功
    handleAvatarSuccess(res, file) {
      let good_key = String(file.response.key);
      // let sku_key = this.skuList[good_key].toString();
      let color= this.checkList[0]['list'][good_key]
      let sku_key=color

      let filename = file.response.upload_filename;
      if (!(sku_key in this.skuListReg)) {
        this.$set(this.skuListReg, sku_key, {"data":[{ name: color, url: filename }],id:0});
      } else {
        this.skuListReg[sku_key]['data'].push({ name: color, url: filename });
      }
      //更新数据
      this.updateAttr();

    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG,PNG 格式!");
      }

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }

      return (isPNG || isJPG) && isLt2M;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          this.$message("请输入正确信息");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      console.log("editor ready!", quill);
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.ruleForm.content = html;
    },

    saveData() {
      // if (this.skuList.length !== Object.keys(this.goods_pic_url).length) {
      //   this.$message("请正确上传图片");
      //   return;
      // }
      // if (this.skuList.length !== this.price.length) {
      //   this.$message("请输入价格");
      //   return;
      // }
      // if (this.skuList.length !== this.qty.length) {
      //   this.$message("请输入数量");
      //   return;
      // }
        if(this.skuList.length==0){
            this.$message.error("请先勾选规格");
            return

        }
      this.editGoodsAction({
        id: this.id,
        goods_pic: JSON.stringify(this.skuListReg),
        cate_path:JSON.stringify(this.cate_path),
        goods: JSON.stringify(this.ruleForm),
        sku: JSON.stringify(this.skuList),
        qty: JSON.stringify(this.qty),
        stock_ids: JSON.stringify(this.skuId),
        price: JSON.stringify(this.price),
        goods_show_pic: JSON.stringify(this.goods_show_pic),
      });
    },
    handleClick() {
      // 先清空数据，保证连续点击按钮，数据不会重复
      this.skuArray = [];
      this.skuList = [];


      // 将选中的规格组合成一个大数组 [[1, 2], [a, b]...]
      this.checkList.forEach((element) => {
        element.list.length > 0 ? this.skuArray.push(element.list) : "";
      });

      if (this.checkList.length < 2) {

          return;
      }

      // 勾选了规格，才调用方法
      if (this.skuArray.length > 0) {
        this.getSkuData([], 0, this.skuArray);

        // this.changeLength(this.skuList.length, this.qty, "qty");
        // this.changeLength(this.skuList.length, this.price, "price");

        // this.changeLength(this.skuList.length, this.goods_pic_url, "pic");
        // this.goods_pic_url = new Array(this.skuList.length).fill([]);
          for(let i=0;i<this.checkList[0]['list'].length;i++){
              let sku_key=this.checkList[0]['list'][i];
              if (!(sku_key in this.skuListReg)) {
                  this.$set(this.skuListReg, sku_key.toString(),{"data":[],"id":0});

                 // this.changeProductPic()


              }
          }



        if (this.skuList.length > 0) {
          this.updateAttr();
          this.deleteAttr()
        }
      } else {
        this.$message.error("请先勾选规格");
        // this.updateSkuList();
      }
      //   console.log(this.res_files.length);
    },
    // 递归获取每条SKU数据
    getSkuData(skuArr = [], i, list) {
      if (list.length < 2) {
        return;
      }
      for (let j = 0; j < list[i].length; j++) {
        if (i < list.length - 1) {
          skuArr[i] = list[i][j];

          this.getSkuData(skuArr, i + 1, list); // 递归循环
        } else {
          this.skuList.push([...skuArr, list[i][j]]); // 扩展运算符，连接两个数组
        }
      }
    },
    //更新图片信息
      changeProductPic(){

        for (let i = 0; i < this.checkList[0]['list'].length; i++) {
            let sku_k = this.checkList[0]['list'][i]


            if (sku_k in this.skuListReg) {
                this.$set(this.goods_pic_url, i, this.skuListReg[sku_k]);
            }
        }
    },
    changeLength(len, arr, type) {
      //设置要更改数组的长度
      var newLength = len;

      // 新数组的长度 - 原来数组的长度
      var addLength = newLength - arr.length;

      if (addLength < 0) {
        addLength = 1;
      }
      var newArr = [];
      newArr.length = addLength;
      //把一个数组合并到原来的数组里

      if (type == "qty") {
        arr = this.qty.concat(newArr);

        this.qty = arr;
      }
      if (type == "price") {
        arr = this.price.concat(newArr);
        this.price = arr;

      }
      //   if (type == "pic") {
      //     newArr.fill([]);
      //     console.log("pic_start", this.goods_pic_url, "len", this.goods_pic_url.length, "newArr", newArr.length);
      //     let goods_arr;
      //     goods_arr = this.goods_pic_url.concat(newArr);

      //     this.goods_pic_url = goods_arr;

      //   }
    },
    //删除不存在的属性
    deleteAttr(){
       let len= this.skuList.length;
       let key=0;
        let exist=0;
        let sku_key=0

        for (let k in this.skuId){


            for(var i=0;i<len;i++){
                key=this.skuList[i].toString()
                console.log("k",k,"key",key)
                if(key==k){
                    exist=1

                   break
                }else{
                    exist=0
                }

            }
            console.log("exist",exist)
            if(exist==0){
                this.$delete(this.skuId,k)
                this.$delete(this.skuId,k)
                this.$delete(this.price,k)
                this.$delete(this.qty,k)

            }

        }

        for (let k in this.skuListReg){


            for(let i=0;i<len;i++){
                key=this.skuList[i][0]

                if(key==k){
                    exist=1

                    break
                }else{
                    exist=0
                }

            }
            console.log("exist",exist)
            if(exist==0){

                this.$delete(this.skuListReg,k)

            }

        }

        console.log(key,exist,sku_key)

        // for (let item in this.skuList){
        //
        //
        //
        //     // for (let j=0;j<len;j++){
        //     //     key=this.skuList[j].toString()
        //     //
        //     //
        //     //
        //     //
        //     // }
        //
        //
        //     //不存在删除
        //     // if(exits==0){
        //     //
        //     //
        //     //     this.$delete(this.skuListAttrReg,item)
        //     //     this.$delete(this.skuListAttrIdReg,item)
        //     //     this.$delete(this.skuId,item)
        //     //     this.$delete(this.price,item)
        //     //     this.$delete(this.qty,item)
        //     //
        //     //
        //     // }
        //
        // }


    },

    //更改页面属性
    updateAttr() {
      // for (let i = 0; i < this.skuList.length; i++) {
      //   let sku_k = this.skuList[i].toString();
      //
      //   if (sku_k in this.skuListReg) {
      //     this.$set(this.goods_pic_url, i, this.skuListReg[sku_k]);
      //   }
      // }
      //   for (let i = 0; i < this.checkList[0]['list'].length; i++) {
      //       let sku_k = this.checkList[0]['list'][i]
      //
      //
      //       // if (sku_k in this.skuListReg) {
      //       //     this.$set(this.goods_pic_url, i, this.skuListReg[sku_k]);
      //       // }
      //   }

      //价格与数量
      for (let i = 0; i < this.skuList.length; i++) {
        let sku_k = this.skuList[i].toString();


          if (!(sku_k in this.skuId)) {
              this.$set(this.skuId, sku_k,0);

          }
          if (!(sku_k in this.price)) {
              this.$set(this.price, sku_k, 0);

          }
          if (!(sku_k in this.qty)) {
              this.$set(this.qty, sku_k, 0);

          }

      }
    },
    updateSkuList() {
      for (let i = 0; i < this.checkList.length; i++) {
        this.checkList[i].list = [];
        // this.$set(this.checkList[i]["list"], "checked", false);
      }
    },
      IterationDelateMenuChildren(arr) {
          if (arr.length > 0) {
              for (let i in arr) {
                  if (arr[i].children.length) {
                      this.IterationDelateMenuChildren(arr[i].children);
                  } else {
                      arr[i].children = undefined;
                  }
              }
          }
          return arr;
      },
      change(val) {
          console.log(val);



         this.cate_path=val


          let len=val.length

          let node_cate=0
          if(len>0){
              let node= val[len-1]

              let node_item=node.split("_")
              if(node_item.length>0){
                  node_cate=node_item[0]

              }



          }else{
              node_cate=""
          }

          // if(nodes.length>0){
          //
          //     alert(nodes[len-1])
          // }

          // let node=0
          // if(len>0){
          //     node=val[len-1].toString()
          // }

          // this.area_content=[]
          // let nodes=this.$refs.cascader.getCheckedNodes()
          // console.log(nodes)
          // for (let i=0;i<nodes.length; i++){
          //     this.area_content[i]=nodes[i]['pathLabels']
          //     console.log(nodes[i]['pathLabels'])
          // }
          // console.log(this.area_content);

          this.ruleForm.goods_cate =node_cate;
      },
  },
  created() {
    this.id = this.$route.params.id;
    this.getAttrDataAction({});

    this.getCategoryDataAction({});
  },
  mounted() {},

  watch: {
    checkList(newdata, olddata) {

      console.log("checkList", newdata, olddata);
    },
    attr(newdata, olddata) {
      let attr_color = [];


      for (let i = 0; i < newdata.data.length; i++) {
        let name = newdata.data[i]["name"];

        let item = { name: name };
        let item_list = [];
        for (let j = 0; j < newdata.data[i]["list"].length; j++) {
          item_list.push(newdata.data[i]["list"][j]["name"]);
        }
        item["list"] = item_list;
        console.log(item["list"])
        attr_color.push(item);
      }
      let check_list = [];

      for (let i = 0; i < newdata.check_list.length; i++) {
        let name = newdata.check_list[i]["name"];

        let item = { name: name, list: [] };

        check_list.push(item);
      }

      this.attrs = attr_color;
      this.checkList = check_list;
      console.log("checkList", newdata, olddata);
      this.editGoodsAction({ id: this.id, type: "get" });
    },

    result(newdata, olddata) {
      console.log(newdata, olddata);

      if (newdata.code == 200) {

        this.ruleForm.name = newdata.data.title;
        this.ruleForm.art_num = newdata.data.art_num;
        this.ruleForm.tag_price = newdata.data.tag_price;
        this.ruleForm.weight = newdata.data.weight;
        this.ruleForm.price = newdata.data.price;
        this.ruleForm.goods_cate = newdata.data.cate;
        this.cate_path=JSON.parse(newdata.data.cate_path)
        this.ruleForm.content = newdata.data.body;
        this.default_options = JSON.parse(newdata.data.cate_path);


        // this.goods_show_pic = JSON.parse(newdata.data.pic);
        this.goods_show_pic = newdata.data.pic;
        let skuList_arr = new Array(newdata.data["product_stock"].length);

        for (let i = 0; i < newdata.data["product_stock"].length; i++) {
          let color_label = newdata.data["product_stock"][i]["color_label"];
          let size_label = newdata.data["product_stock"][i]["size_label"];
          console.log("skuList_arr", skuList_arr, color_label, size_label);
          this.$set(skuList_arr, i, [color_label, size_label]);
          if (this.checkList[0].list.indexOf(color_label) == -1) {
            this.checkList[0].list.push(color_label);
          }
          if (this.checkList[1].list.indexOf(size_label) == -1) {
            this.checkList[1].list.push(size_label);
          }



          // this.$set(this.skuListAttrIdReg, color_label + "," + size_label,  newdata.data["product_stock"][i]["id"]);
          // this.$set(this.skuId, i, newdata.data["product_stock"][i]["id"]);
          this.$set(this.skuId,color_label + "," + size_label, newdata.data["product_stock"][i]["id"]);
          // this.$set(this.skuListAttrReg, color_label + "," + size_label, [
          //   newdata.data["product_stock"][i]["price"],
          //   newdata.data["product_stock"][i]["qty"],
          // ]);
            this.$set(this.qty,color_label + "," + size_label,newdata.data["product_stock"][i]["qty"])
          // this.qty.push(newdata.data["product_stock"][i]["qty"]);
          // this.price.push(newdata.data["product_stock"][i]["price"]);
            this.$set(this.price,color_label + "," + size_label,newdata.data["product_stock"][i]["price"])
          // skuList_arr[i][0] = color_label;
          // skuList_arr[i][1] = size_label;
        }
        // console.log("skuList_arr", skuList_arr);


          //产品图片颜色
         for(let i=0;i<newdata.data.product_pic.length;i++){

             // let json =JSON.parse(newdata.data["product_pic"][i]['pic']) ;
             let json =newdata.data["product_pic"][i]['pic'];
             let product_pic_data=newdata.data["product_pic"][i];

             this.$set(json, 'id' , product_pic_data['id']);

             let product_json_data={"data":json,id: product_pic_data['id']}
             this.$set(this.skuListReg, product_pic_data["name"] , product_json_data);


         }
        // console.log(newdata.data.product_pic)
        this.skuList = skuList_arr;


      }

      if (newdata.code == 301) {
        this.$message({
          message: "恭喜你，修改成功",
          type: "success",
        });

        setTimeout(() => {
          this.$router.push({ name: "goods_index" });
        }, 600 * Math.random());

        this.goods_pic_url = [];

        this.goods_show_pic = [];

        this.skuArray = [];
        this.skuList = [];
        this.skuListReg = {};
        this.skuListAttrReg = {};
        this.skuListAttrIdReg = {};
        this.skuId = [];
        this.price = [];
        this.qty = [];
        this.updateSkuList();
        this.$refs.pic_show.clearFiles();
        this.$refs.ruleForm.resetFields();
      }
    },
      category(newdata, olddata) {

          if(newdata.code==200){

              this.cate_option=  this.IterationDelateMenuChildren( newdata.data)
          }
          console.log(newdata, olddata);
      },

   // skuList(newdata, olddata){
   //
   //      if(olddata.length>0){
   //          for (let i=0;i<olddata.length;i++){
   //
   //
   //          }
   //
   //      }
   // }




  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
.quill-editor {
  height: 400px;
}

.quill-editor-bottom {
  margin-bottom: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #260a0a;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.title_bg {
  background-color: #f5fffa;
  padding: 10px;
}

.el-form-item__content {
  margin-left: 30px;
}
.box_text{
    display:block;
    padding: 5px;
    top:5px;
    float:right
}
</style>
